import { useCallback } from 'react';

import { ToniAIEmailRequest } from '../types';

const TONI_AI_API_URL = process.env.NX_PUBLIC_TONI_AI_API_URL;

const API_KEY = process.env.NX_PUBLIC_TONI_AI_API_KEY;

const defaultHeaders = {
  'X-Api-Key': API_KEY,
  'Content-Type': 'application/json',
};

export const useToniAIApi = (props: { threadId: string }) => {
  const { threadId } = props;

  const getEmail = useCallback(
    (props: ToniAIEmailRequest) => {
      return fetch(`${TONI_AI_API_URL}/conversation/email`, {
        method: 'post',
        headers: defaultHeaders,
        body: JSON.stringify({
          ...props,
          thread_id: threadId,
        } as ToniAIEmailRequest),
      });
    },
    [threadId]
  );

  return { getEmail };
};
